import { get } from 'lib/actionHelpers.js';
import { format } from 'date-fns';
import getWeekRange from 'screens/todos/lib/getWeekRange';

export const getTodos = (serviceProviderId, data, callback, action = null) => {
  return get(`/todo/list`, {
    query: {
      ...data,
      service_provider_id: serviceProviderId,
      offset: 0,
      status_id: data.status_id === true ? undefined : data.status_id,
    },
    action: action ? action : 'GET_TODOS',
    callback,
  });
};

export const getOverdueTodos = (serviceProviderId, userId = null, callback, action = null) => {
  return get(`/todo/list`, {
    query: {
      service_provider_id: serviceProviderId,
      limit: 500,
      target_start_date: format(new Date('2020-01-01'), 'yyyy-MM-dd'),
      target_end_date: format(new Date(), 'yyyy-MM-dd'),
      assignee_user_id: !userId ? undefined : userId,
      status_id: '1',
      offset: 0,
    },
    action: action ? action : 'GET_OVERDUE_TODOS',
    callback,
  });
};

export const getTodosDueToday = (serviceProviderId, userId = null, callback, action = null) => {
  const dateRangeCurrentWeek = getWeekRange();
  return get(`/todo/list`, {
    query: {
      service_provider_id: serviceProviderId,
      limit: 500,
      target_start_date: format(dateRangeCurrentWeek.startDate, 'yyyy-MM-dd'),
      target_end_date: format(dateRangeCurrentWeek.endDate, 'yyyy-MM-dd'),
      assignee_user_id: !userId ? undefined : userId,
      status_id: '1',
      offset: 0,
    },
    action: action ? action : 'GET_TODOS_DUE_TODAY',
    callback,
  });
};
